import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {QtyType} from '@/enum/order';
import {uiMsg$} from '@/ui';

export const qtyTypeBeforeV2$ = new BehaviorSubject<QtyType>(QtyType.Coin);
export const qtyTypeV2$ = new BehaviorSubject<QtyType>(QtyType.Coin);

export interface FUQtyBeforeV2Change {
  type: 'qty-before-v2-change';
  qtyType: QtyType;
}
export interface FUQtyV2Change {
  type: 'qty-v2-change';
  qtyType: QtyType;
}
uiMsg$
  .pipe(
    filter((o) => o.type === 'qty-before-v2-change'),
    map((e: FUQtyBeforeV2Change) => e.qtyType)
  )
  .subscribe((e) => qtyTypeBeforeV2$.next(e));

uiMsg$
  .pipe(
    filter((o) => o.type === 'qty-v2-change'),
    map((e: FUQtyV2Change) => e.qtyType)
  )
  .subscribe((e) => qtyTypeV2$.next(e));
